import * as React from "react";
import { Box, Stack } from "@mui/material";
import { colors } from "@/styles/constants";
import { ServiceProviderType } from "@/types/index";
import { FieldRow, FieldsTable } from "../../../../components/molecules/FieldsTable";
import { Responsible } from "./Responsible";
import { readableAccountNextSteps } from "@/utils/accounts";
import { AccountDisplayInfo } from "./AccountDetails";

export const SocialMediaOrEmailAccount: React.FC<AccountDisplayInfo> = ({
  persons,
  account,
  documents,
}) => {
  const { serviceProviderType, emailAddress, phoneNumber, profileUrl, nextSteps, responsibleId } =
    account;

  return (
    <FieldsTable>
      <FieldRow label="Email address" value={emailAddress} />

      {serviceProviderType === ServiceProviderType.SocialMedia && (
        <>
          <FieldRow label="Phone number" value={phoneNumber} />

          <FieldRow label="Profile link" value={profileUrl} />
        </>
      )}

      <FieldRow
        label="Next step"
        value={readableAccountNextSteps(nextSteps, serviceProviderType)}
      />

      <FieldRow
        label="Responsible"
        value={<Responsible persons={persons} responsibleId={responsibleId} />}
      />

      {documents && documents.length > 0 && (
        <FieldRow
          label="Documents"
          value={
            <Stack>
              {documents.map((doc, index) => (
                <Box key={index}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={doc.downloadUrl}
                    style={{ color: colors.primary }}
                  >
                    {doc.filename}
                  </a>
                </Box>
              ))}
            </Stack>
          }
        />
      )}
    </FieldsTable>
  );
};
